import { render, staticRenderFns } from "./CompendiumPageButton.vue?vue&type=template&id=3417970d&scoped=true&"
import script from "./CompendiumPageButton.vue?vue&type=script&lang=ts&"
export * from "./CompendiumPageButton.vue?vue&type=script&lang=ts&"
import style0 from "./CompendiumPageButton.vue?vue&type=style&index=0&id=3417970d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3417970d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VCol,VIcon})
